import React from "react";

const AdoptionReportIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="35.165"
      height="43.596"
      viewBox="0 0 35.165 43.596"
    >
      <defs>
        <clipPath id="clip-path">
          <path
            id="Path_1808"
            data-name="Path 1808"
            d="M185,139.21h30.47v33.121H185Z"
            transform="translate(-185 -139.21)"
            fill={fill}
          />
        </clipPath>
        <clipPath id="clip-path-2">
          <path
            id="Path_1810"
            data-name="Path 1810"
            d="M236,253h30.47v33.121H236Z"
            transform="translate(-236 -253)"
            fill={fill}
          />
        </clipPath>
      </defs>
      <g id="db95" transform="translate(-185 -139.21)">
        <path
          id="Path_1806"
          data-name="Path 1806"
          d="M264.5,219.57h15.314v.646H264.5Z"
          transform="translate(-72.182 -72.962)"
          fill={fill}
        />
        <g
          id="Group_1415"
          data-name="Group 1415"
          transform="translate(185 139.21)"
          clip-path="url(#clip-path)"
        >
          <path
            id="Path_1807"
            data-name="Path 1807"
            d="M187.557,142.216h25.429v6.548h2.484v-9.552h-30.4v33.041h3.752v-2.482h-1.269Z"
            transform="translate(-185.067 -139.213)"
            fill={fill}
          />
        </g>
        <g
          id="Group_1416"
          data-name="Group 1416"
          transform="translate(189.695 149.685)"
          clip-path="url(#clip-path-2)"
        >
          <path
            id="Path_1809"
            data-name="Path 1809"
            d="M236.73,253.857V286.9h26.533c1.978,0,3.863-2.336,3.863-4.95V253.857Zm26.533,30.038h-24.05V256.86h25.43v25.088h0c0,.779-.554,1.947-1.381,1.947Z"
            transform="translate(-236.663 -253.778)"
            fill={fill}
          />
        </g>
        <path
          id="Path_1811"
          data-name="Path 1811"
          d="M316.16,334.23h15.313v1.948H316.16Z"
          transform="translate(-119.086 -177.067)"
          fill={fill}
        />
        <path
          id="Path_1812"
          data-name="Path 1812"
          d="M395.09,390.43h9.794v11.292H395.09Z"
          transform="translate(-190.75 -228.094)"
          fill={fill}
        />
        <path
          id="Path_1813"
          data-name="Path 1813"
          d="M306.66,390.43h5.84v1h-5.84Z"
          transform="translate(-110.461 -228.094)"
          fill={fill}
        />
        <path
          id="Path_1814"
          data-name="Path 1814"
          d="M306.66,460.52h5.84v1h-5.84Z"
          transform="translate(-110.461 -291.732)"
          fill={fill}
        />
        <path
          id="Path_1815"
          data-name="Path 1815"
          d="M306.66,528.2h5.84v1h-5.84Z"
          transform="translate(-110.461 -353.181)"
          fill={fill}
        />
        <path
          id="Path_1816"
          data-name="Path 1816"
          d="M306.66,426.07h5.84v1h-5.84Z"
          transform="translate(-110.461 -260.453)"
          fill={fill}
        />
        <path
          id="Path_1817"
          data-name="Path 1817"
          d="M306.66,493.76h5.84v1h-5.84Z"
          transform="translate(-110.461 -321.912)"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default AdoptionReportIcon;
